import { Breadcrumb } from '@repo/ui/components/ui/breadcrumb';
import { Card } from '@repo/ui/components/ui/card';
import { GroupeForm } from '@repo/ui/features/groupe/groupe-form';
import { PageHeader } from '@repo/ui/ui/layout/page-header';
import { useNavigate, useParams } from 'react-router-dom';

export default function GroupeEditPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const goToList = () => navigate('/admin/droits/groupe');

  return (
    <div className="space-y-4">
      <div className="mb-2">
        <Breadcrumb
          items={[
            { label: 'Gestion' },
            { label: 'Groupes', href: '/admin/droits/groupe' },
            { label: 'Modifier le groupe', current: true },
          ]}
          showHomeIcon
          onHomeClick={() => navigate('/admin/dashboard')}
          className="mb-4"
        />
      </div>

      <PageHeader>
        <PageHeader.Title>Modifier le Groupe</PageHeader.Title>
      </PageHeader>

      <Card className="p-4">
        <GroupeForm
          groupeId={id ? parseInt(id, 10) : undefined}
          onCancel={goToList}
          onSuccess={goToList}
        />
      </Card>
    </div>
  );
}
